// extracted by mini-css-extract-plugin
export var circle = "_2b-2";
export var icon = "_2b-a";
export var iconHighlight = "_2b-0";
export var lg = "_2b-8";
export var md = "_2b-7";
export var outline = "_2b-4";
export var sm = "_2b-6";
export var square = "_2b-1";
export var xl = "_2b-9";
export var xs = "_2b-5";
export var xxs = "_2b-3";